import { ScrapbookFile } from '@/api/scrapbook-data';
import { ScrapbookContentType } from '@/types';
import StatPreview from './StatPreview';
import AIChatPreview from './AIChatPreview';
import AISummaryPreview from './AISummaryPreview';
import ArticleExtractPreview from './ArticleExtractPreview';
import ColourPreview from './ColourPreview';
import ColourPalettePreview from './ColourPalettePreview';
import QuotePreview from './QuotePreview';
import FilePreview from './FilePreview';
import ImagePreview from './ImagePreview';
import TechLaunchDatabasePreview from './TechLaunchDatabasePreview';
import AnalyticsBuilderPreview from './AnalyticsBuilderPreview';
import AnalyticsBuilderSectionPreview from './AnalyticsBuilderSectionPreview';
interface ContentPreviewProps {
  content: ScrapbookFile | null;
  onClose: () => void;
}

const ContentPreview = ({ content, onClose }: ContentPreviewProps) => {
  if (content?.contentType === ScrapbookContentType.AIChat) {
    return <AIChatPreview content={content} onClose={onClose} />;
  } else if (content?.contentType === ScrapbookContentType.AISummary) {
    return <AISummaryPreview content={content} onClose={onClose} />;
  } else if (content?.contentType === ScrapbookContentType.ArticleExtract) {
    return <ArticleExtractPreview content={content} onClose={onClose} />;
  } else if (content?.contentType === ScrapbookContentType.Colour) {
    return <ColourPreview content={content} onClose={onClose} />;
  } else if (content?.contentType === ScrapbookContentType.ColourPalette) {
    return <ColourPalettePreview content={content} onClose={onClose} />;
  } else if (content?.contentType === ScrapbookContentType.Image) {
    return <ImagePreview content={content} onClose={onClose} />;
  } else if (content?.contentType === ScrapbookContentType.Quote) {
    return <QuotePreview content={content} onClose={onClose} />;
  } else if (content?.contentType === ScrapbookContentType.Stat) {
    return <StatPreview content={content} onClose={onClose} />;
  } else if (content?.contentType === ScrapbookContentType.TechLaunchDatabase) {
    return <TechLaunchDatabasePreview content={content} onClose={onClose} />;
  } else if (content?.contentType === ScrapbookContentType.AnalyticsBuilder) {
    return <AnalyticsBuilderPreview content={content} onClose={onClose} />;
  } else if (content?.contentType === ScrapbookContentType.AnalyticsBuilderSection) {
    return <AnalyticsBuilderSectionPreview content={content} onClose={onClose} />;
  } else {
    return <FilePreview content={content} onClose={onClose} />;
  }
};

export default ContentPreview;
